import React from 'react';

const Login = React.lazy(() => import('../pages/PublicViews/Login.js'));
const Register = React.lazy(() => import('../pages/PublicViews/Register.js'));

const PublicRoutes = [
    { path: 'login', name: 'Login', element: <Login /> },
    { path: 'register', name: 'Register', element: <Register /> },
];

export default PublicRoutes;
